import { render, staticRenderFns } from "./ui-button-multi.vue?vue&type=template&id=a9c6d85e&"
import script from "./ui-button-multi.vue?vue&type=script&lang=ts&"
export * from "./ui-button-multi.vue?vue&type=script&lang=ts&"
import style0 from "./ui-button-multi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports